import styled from 'styled-components';
import {palette} from '@/styles';

export const SwiperSlideCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid ${palette.gray200};
  background-color: ${palette.white};
`;
